import React from 'react'
import PropTypes from 'prop-types'
import { ToggleButtonGroup } from '@material-ui/lab'
import SegmentedToggleButton from 'components/segmented-toggle-button'
import useCalendarStyles from './calendar/calendar-styles'

const ScheduleSegmentControl = ({
  value,
  onChange,
  options,
  ariaLabel,
  isMobile = false,
}) => {
  const classes = useCalendarStyles()

  return (
    <ToggleButtonGroup
      exclusive
      value={value}
      onChange={onChange}
      className={`${classes.segmentControl} ${
        isMobile ? classes.mobileSegmentControl : ''
      }`}
      aria-label={ariaLabel}
    >
      {options.map(option => (
        <SegmentedToggleButton
          key={option.value}
          value={option.value}
          groupValue={value}
          showCheck={false}
          className={`${classes.segmentButton} ${
            isMobile ? classes.mobileSegmentButton : ''
          }`}
        >
          {option.label}
        </SegmentedToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}

ScheduleSegmentControl.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  ariaLabel: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
}

export default ScheduleSegmentControl
